import React, { useEffect, useState } from "react";
import { setFilterAnd, uuid } from "../../Utils/Utils";
import { useSelector } from "react-redux";
const { $ } = window;

const WIDTH = window.innerWidth;

const Filter = ({
  mTableId,
  closeFilter,
  openFilter,
  filter,
  filters,
  onFilterFieldChange,
  columns,
  onFilterValueChange,
  onValueEnter,
  onAddFilter,
  onRemoveFilter,
  onResetFilter,
  hideFilter,
  customFilter,
  filterChilds,
  filterChildId,
}) => {
  const darkMode = useSelector((state) => state.theme.darkMode);

  const [state, setState] = useState({
    options: [],
    isFiltered: false,
  });

  const onFilterFieldChangeHandler = (e) => {
    const filterIndex = columns.findIndex(
      (item) => item.field == e.target.value
    );
    if (columns[filterIndex].options) {
      setState({ ...state, options: columns[filterIndex].options });
    } else {
      setState({ ...state, options: [] });
    }
    onFilterFieldChange(e);
  };

  const onAddFilterHandler = () => {
    if ($("#filter_value").val() != "") {
      setState({ ...state, options: [] });
      onAddFilter();
    }
  };

  const onFilter = (e) => {
    $(`#${filterChildId}`).modal("show");
  };

  useEffect(() => {
    setState({ ...state, isFiltered: filterChilds && customFilter });
  }, [customFilter]);

  return (
    <div>
      <div id={`${mTableId}_filter`} className="filterContainer">
        <div className="card" style={{ height: "100%" }}>
          <div className="card-header" style={{ height: 40, paddingTop: 7 }}>
            <div className="card-title" style={{ fontSize: 16 }}>
              <i className="fa fa-filter" /> Filter
            </div>
            <div className="card-tools" style={{ marginTop: -7 }}>
              <button
                type="button"
                className="btn btn-outline"
                onClick={closeFilter}
              >
                <i className="fa fa-times" />
              </button>
            </div>
          </div>
          <div className="card-body">
            <div className="d-flex" style={{ justifyContent: "space-between" }}>
              <div style={{ flex: 1 }}>
                <select
                  className="form-control rounded-0"
                  name="filter_field"
                  value={filter.field}
                  onChange={(e) => onFilterFieldChangeHandler(e)}
                >
                  <option value={""}>Select field</option>
                  {columns
                    .filter((item) => item.field)
                    .filter(
                      (e) =>
                        filters
                          .map((d) => d.field)
                          .join()
                          .indexOf(e.field) == -1
                    )
                    .map(
                      (col, i) =>
                        col.filterable !== false && (
                          <option key={`key-option-${i}`} value={col.field}>
                            {col.title}
                          </option>
                        )
                    )}
                </select>
              </div>
              <div style={{ width: 10 }} />
              <div style={{ flex: 1 }}>
                {state.options.length > 0 ? (
                  <select
                    name="filter_value"
                    id="filter_value"
                    className="form-control rounded-0"
                    onChange={onFilterValueChange}
                  >
                    <option key={uuid()} value="">
                      -Selec Value-
                    </option>
                    {state.options.map((opt) => (
                      <option key={opt.label} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    name="filter_value"
                    className="form-control"
                    placeholder="Filter value"
                    value={filter.value}
                    onChange={onFilterValueChange}
                    onKeyDown={onValueEnter}
                  />
                )}
              </div>
              <div style={{ width: 10 }} />
              <div>
                <button
                  type="button"
                  className="btn  btn-outline-warning"
                  onClick={onAddFilterHandler}
                >
                  <i className="fa fa-plus" />
                </button>
              </div>
            </div>
            <div style={{ height: 1, background: "#ccc", margin: "10px 0" }} />
            <div
              className="hideScrollbar"
              style={{
                height: 220,
                overflowY: "scroll",
                border: "solid 0px #ccc",
              }}
            >
              <div className="d-flex" style={{ flexDirection: "column" }}>
                <div>
                  {filters.map((item, i) => (
                    <div
                      key={`item_filter_${i}`}
                      className="d-flex"
                      style={{ flexDirection: "column" }}
                    >
                      <div
                        key={`key-item-filter-${i}`}
                        className="d-flex"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ flex: 1 }}>{item.title}</div>
                        <div style={{ margin: "0 10px", color: "orangered" }}>
                          contains
                        </div>
                        <div
                          style={{
                            flex: 1,
                            color: "darkblue",
                            fontStyle: "italic",
                          }}
                        >
                          {item.value + ""}
                        </div>
                        <div>
                          <button
                            type="button"
                            className="btn btn-outline"
                            onClick={onRemoveFilter(item)}
                          >
                            <i
                              className="fa fa-times"
                              style={{ color: "red" }}
                            />
                          </button>
                        </div>
                      </div>
                      <div
                        style={{
                          height: 1,
                          background: "#ccc",
                          margin: "6px 0",
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="d-flex mt-3" style={{ justifyContent: "center" }}>
              <button
                type="button"
                className="btn btn-sm btn-outline-danger"
                onClick={onResetFilter}
                style={{ width: 100 }}
              >
                <i className="fa fa-times" /> Reset
              </button>
            </div>
          </div>
        </div>
      </div>
      {!hideFilter && (
        <div
          className="d-flex mb-3"
          style={filterChilds ? { width: "100%" } : { width: "101.5%" }}
        >
          <div
            id={`buttonFilter_${mTableId}`}
            style={filterChilds}
            className="mr-2"
          >
            <button
              type="button"
              className={`btn btn-block ${
                darkMode ? "btn-outline-warning" : "btn-outline-dark"
              }`}
              onClick={openFilter}
            >
              <i className="fa fa-filter" /> Filter{" "}
              {filters.length > 0 && (
                <span className="badge badge-danger">{filters.length}</span>
              )}
            </button>
          </div>

          {filterChilds && (
            <div id={`buttonFilterChild_${filterChildId}`}>
              <button
                type="button"
                className={`btn btn-block ${
                  darkMode ? "btn-outline-warning" : "btn-outline-dark"
                }`}
                onClick={onFilter}
              >
                <i className="fa fa-filter" /> Advanced
                {state.isFiltered && (
                  <span
                    className="badge badge-danger"
                    style={{ marginLeft: 5 }}
                  >
                    •
                  </span>
                )}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Filter;
